import { CheckCircle } from '@phosphor-icons/react';

export default function ThanksPage() {
  return (
    <div className="max-w-[700px] mx-auto px-4 py-16 text-center">
      <div className="flex items-center justify-center mb-3">
        <CheckCircle size={36} weight="duotone" className="text-brand-primary" />
      </div>
      <h1 className="text-2xl font-semibold mb-2">Mulțumim!</h1>
      <p className="text-gray-700 mb-6">Am primit informațiile trimise. Revenim cât de curând cu un răspuns.</p>
      <p className="text-sm text-gray-500">Poți închide această pagină în siguranță.</p>
    </div>
  );
}


